

// TODO: reminder to self: update package regularly so this -> https://github.com/bubkoo/html-to-image/issues/257#issuecomment-1284384683
// hopefully got merged in the meantime (error: "failed to parse source map error" on npm run start)
import * as htmlToImage from 'html-to-image'

/**
 * 
 * @returns base64 encoded image data
 */
export const generatePreviewImage = async (): Promise<string> => {
  const editorNode = document.querySelector('.ql-editor') as HTMLElement

  if (!editorNode) {
    return Promise.resolve('')
  }

  const image = await htmlToImage.toPng(editorNode)
    .then((dataUrl) => {
      /*
        Usually, 'return dataUrl' would be enough. However, in order to avoid any styling issues,
        we need to draw the image on a canvas, set the background to white and then convert it back to a dataUrl.
        This way, it doesn't matter what the background color of the editor is, or, more importantly, will be.
        (Maybe there will be different themes for the editor itself in the future.)
        Furthermore, all preview pictures will have the same background color -> consistency.
      */
      const originalWidth = editorNode.offsetWidth
      const originalHeight = editorNode.offsetHeight

      const canvas = document.createElement('canvas')
      canvas.width = originalWidth
      canvas.height = originalHeight

      const ctx = canvas.getContext('2d')

      if (!ctx) {
        console.error("Editor.tsx: no canvas context found. Using background color of user as fallback.")

        return dataUrl
      }

      ctx.fillStyle = 'white'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      const image = new Image()
      image.src = dataUrl

      return new Promise((resolve) => {
        image.onload = () => {
          ctx.drawImage(image, 0, 0)
  
          const modifiedDataUrl = canvas.toDataURL()
  
          resolve(modifiedDataUrl)
        }
      })
    })

  return image as string
}
